// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CarouselTokens } from './type';

const carouselTokens: CarouselTokens = {
  carouselArrowMargin: 'Spacing-18',
  carouselArrowSize: 'Size-12',
  carouselArrowIconSize: 'Size-10',
  carouselArrowBackgroundColor: 'rgba(255, 255, 255, 0.2)',
  carouselArrowBorderRadius: 'Radius-default',
  carouselArrowFontColor: 'Neutral-text-1',
  carouselArrowHoverBackgroundColor: 'rgba(255, 255, 255, 0.4)',
  carouselIndicatorBackgroundColor: 'Neutral-fill-4',
  carouselIndicatorActiveBackgroundColor: 'Neutral-fill-1',
  carouselIndicatorWrapperHeight: 'Size-20',
  carouselIndicatorCircleWidth: 'Size-3',
  carouselIndicatorCircleGap: 'Spacing-8',
  carouselIndicatorLineWidth: 'Size-6',
  carouselIndicatorLineHeight: 'Size-2',
  carouselIndicatorLineGap: 'Spacing-4',
  carouselIndicatorBarWidth: 'Size-12',
  carouselIndicatorBarHeight: 'Size-2',
  carouselIndicatorArrowSize: 'Size-8',
  carouselIndicatorArrowColor: 'Neutral-fill-4',
  carouselIndicatorArrowHoverColor: 'Neutral-fill-1',
  carouselIndicatorNumberColor: 'Neutral-fill-1',
  carouselIndicatorNumberFontSize: 'Font-14',
  carouselIndicatorOuterBackgroundColor: 'Neutral-fill-4',
  carouselIndicatorOuterActiveBackgroundColor: 'Neutral-fill-6',
  carouselIndicatorOuterArrowColor: 'Neutral-text-4',
  carouselIndicatorOuterArrowHoverColor: 'Neutral-text-2',
  carouselIndicatorOuterNumberColor: 'Neutral-text-4',
  carouselFontSize: 'Font-14',
};

export default carouselTokens;
